/**
 * App lock behind the device's own biometrics.
 *
 * The browser has no equivalent of `expo-local-authentication`. WebAuthn's
 * platform authenticator can prompt for Face ID / Windows Hello, but only
 * against a credential the SERVER registered and verifies — there is no
 * "just ask the device who this is" call, and faking one client-side would
 * produce a lock screen that any user could step past with the dev tools while
 * telling the fan their tickets were protected. A security control that is
 * decorative is worse than an absent one.
 *
 * So `isBiometricAvailable()` returns false, the Settings toggle hides itself,
 * and `LockGate` never arms. If the API later grows WebAuthn registration
 * (`/me/webauthn/…`), this module is the only file that changes.
 */

/** Always false on the web — see the module header. */
export async function isBiometricAvailable(): Promise<boolean> {
  return false;
}

/** Never called while `isBiometricAvailable()` is false; fails closed if it is. */
export async function authenticate(_promptMessage: string): Promise<boolean> {
  return false;
}
